export default function Tabs(container) {
  const tabs = container;

  const tabList = tabs.getElementsByClassName("js-tab");
  const contentList = document.getElementsByClassName("js-tab-content");
  const fixTabs = document.getElementById("js-page-search-tabs");
  const pageContent = document.querySelector(".main");
  const fixedClass = "is-tabs-fixed";
  let windowWidth = document.body.clientWidth;
  let desctop = false;

  if (windowWidth > 1200) {
    desctop = true;
  }

  if (fixTabs) {
    fixedTabs();
  }

  for (let i = 0, len = tabList.length; i < len; i++) {
    const tabBtn = tabList[i];

    tabBtn.addEventListener("click", function clickTab() {
      const idTab = this.getAttribute("id");
      const activeTab = this;

      for (let n = 0, leng = tabList.length; n < leng; n++) {
        const tab = tabList[n];

        if (activeTab === tab) {
          if (!tab.classList.contains("is-active")) {
            tab.classList.add("is-active");
          }
        } else if (tab.classList.contains("is-active")) {
          tab.classList.remove("is-active");
        }
      }

      for (let j = 0; j < contentList.length; j++) {
        const content = contentList[j];
        const contentId = content.getAttribute("data-id");

        if (contentId === idTab) {
          if (!content.classList.contains("is-show")) {
            content.classList.add("is-show");
          }
        } else if (content.classList.contains("is-show")) {
          content.classList.remove("is-show");
        }
      }
    });
  }

  function fixedTabs() {
    scrolledTabs();

    window.addEventListener("resize", function resizeWidth() {
      windowWidth = document.body.clientWidth;

      if (windowWidth > 1200) {
        desctop = true;
      } else {
        desctop = false;
      }

      scrolledTabs();

      // console.log("desctop", desctop);
    });
  }

  function scrolledTabs() {
    const topTabs = fixTabs.getBoundingClientRect().top;
    window.addEventListener("scroll", function fixedElements() {
      const scrolledY =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrolledY >= topTabs && !desctop) {
        if (!fixTabs.classList.contains(fixedClass)) {
          fixTabs.classList.add(fixedClass);
          pageContent.classList.add(fixedClass);
        }
      } else if (fixTabs.classList.contains(fixedClass)) {
        fixTabs.classList.remove(fixedClass);
        pageContent.classList.remove(fixedClass);
      }
    });

    // console.log("topTabs", topTabs);
  }
}
